export default "__VITE_ASSET__DZd8OC3c__"